import { Component, ElementRef, OnInit, QueryList, ViewChildren } from "@angular/core";

@Component({
  selector: 'app-landing',
  standalone: false,
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements OnInit {

  constructor() { }


  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
  @ViewChildren('content') contents!: QueryList<ElementRef<HTMLDivElement>>;

  openIndex: number | null = null;

  ngAfterViewInit() {
    // Make sure all content divs start with height 0
    this.contents.forEach(el => el.nativeElement.style.height = '0px');
  }

  toggleAccordion(index: number) {
    const el = this.contents.toArray()[index].nativeElement;

    if (this.openIndex === index) {
      // Collapse
      el.style.height = `${el.scrollHeight}px`;
      el.style.padding = '0 4.375rem'; // remove vertical padding
      requestAnimationFrame(() => el.style.height = '0px');
      this.openIndex = null;
    } else {
      // Collapse previously open
      if (this.openIndex !== null) {
        const prevEl = this.contents.toArray()[this.openIndex].nativeElement;
        prevEl.style.height = `${prevEl.scrollHeight}px`;
        prevEl.style.padding = '0 4.375rem';
        requestAnimationFrame(() => prevEl.style.height = '0px');
      }

      // Expand clicked
      el.style.height = `${el.scrollHeight}px`;
      el.style.padding = '2.5rem 4.375rem'; // restore vertical padding
      this.openIndex = index;
    }

    el.addEventListener(
      'transitionend',
      () => {
        if (this.openIndex === index) {
          el.style.height = 'auto'; // responsive content
        }
      },
      { once: true }
    );

  }
}

